import React, { Component } from "react";
import asia from "../Asia";
import FeaturedItems from "../FeaturedItems";

export default class AsiaItems extends Component {
  render() {
    const Asia = asia.map(item => (
      <FeaturedItems key={item.id} item={item} />
    ));
    return (
      <React.Fragment>
        <div className="asia-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">Asia</h1>
        </div>
        <div className="container">
          <div className="row mt-3 justify-content-md-center">{Asia}</div>
        </div>
      </React.Fragment>
    );
  }
}
